module.exports = __webpack_public_path__ + "static/img/partner_9.6fbe612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_9.png
// module id = k2FD
// module chunks = 0